import { Vector3 } from "three";

import { Context } from "../../../context";
import { Actor } from "../../../world/actor/actor";

import { ControllerStrategy } from "../strategy";
import { SpinControllerStrategy } from "./spin";

/**
 * Tracks ball but allows for player control - similar to spin camera
 */
export class BallTrackerControllerStrategy extends SpinControllerStrategy {
  offset: Vector3 = new Vector3(0, 1, 0);

  alphaFactor = 0.025 / 60;

  init(context: Context): ControllerStrategy {
    if (!this.registered) {
      console.error("no controller registered");
      return this;
    }
    super.init(context);

    this.registered.state.tracked = context.world?.ball;

    return this;
  }

  protected findNewActor(
    _context: Context,
    _newPosId: number
  ): Actor | undefined {
    return undefined;
  }
}
